import {
  CustomerModal,
  ForgotPasswordModal,
  GuestModal,
  LoginModal,
  RegisterModal,
  ResetPasswordModal,
} from "../../components";
import { AuthMode } from "../../types/auth";

type AuthModalsProps = {
  activeModal: AuthMode;
  onChange: (mode: AuthMode) => void;
  onClose: () => void;
  onSuccess: () => void;
  allowGuest?: boolean;
};

const AuthModals: React.FC<AuthModalsProps> = ({
  activeModal,
  onChange,
  onClose,
  onSuccess,
  allowGuest = true,
}) => {
  const handleSwitch = (mode: AuthMode) => onChange(mode);

  return (
    <>
      {/* LOGIN */}
      <LoginModal
        show={activeModal === "login"}
        handleSwitch={handleSwitch}
        handleClose={onClose}
        handleSuccess={onSuccess}
        allowGuest={allowGuest}
      />

      {/* REGISTER */}
      <RegisterModal
        show={activeModal === "register"}
        handleSwitch={handleSwitch}
        handleClose={onClose}
        handleSuccess={onSuccess}
      />

      {/* GUEST */}
      <GuestModal
        show={activeModal === "guest"}
        handleSwitch={handleSwitch}
        handleClose={onClose}
        handleSuccess={onSuccess}
      />

      {/* CUSTOMER PROFILE */}
      <CustomerModal
        show={activeModal === "customer"}
        handleClose={onClose}
        handleSuccess={onSuccess}
      />

      {/* FORGOT PASSWORD */}
      <ForgotPasswordModal
        show={activeModal === "forgot-password"}
        handleSwitch={handleSwitch}
        handleClose={onClose}
      />

      {/* RESET PASSWORD */}
      <ResetPasswordModal
        show={activeModal === "reset-password"}
        handleSwitch={handleSwitch}
        handleClose={onClose}
        handleSuccess={onSuccess}
      />
    </>
  );
};

export default AuthModals;